import app from 'flarum/common/app';

app.initializers.add('maisen20/extend-stickiest', () => {
  console.log('[maisen20/extend-stickiest] Hello, forum and admin!');
});
